import {ReactNode} from "react";
import {
  addRoleMemberDialog,
  addTeamMemberDialog,
  confirmationDialog,
  createEditTeamDialog,
  inviteUserDialog,
  reassignTeamDialog,
  reassignUserDialog,
} from ".";
import {provideModal} from "../../components/modals";
import {ModalProvider} from "../../components/modals/ModalProvider";
import ConfirmationDialog from "./ConfirmationDialog";
import ReassignTeamDialog from "./ReassignTeamDialog";
import ReassignUserDialog from "./ReassignUserDialog";
import {InviteUserModal} from "./InviteUserModal";
import {CreateEditTeamModal} from "./CreateEditTeamModal";
import AddRoleMemberModal from "./AddRoleMemberModal";
import AddTeamMemberModal from "./AddTeamMemberModal";

const AppModalProvider = ({children}: {children: ReactNode}) => {
  return (
    <ModalProvider
      modals={[
        provideModal(confirmationDialog, props => <ConfirmationDialog {...props} />),
        provideModal(reassignUserDialog, props => <ReassignUserDialog {...props} />),
        provideModal(reassignTeamDialog, props => <ReassignTeamDialog {...props} />),
        provideModal(inviteUserDialog, props => <InviteUserModal {...props} />),
        provideModal(createEditTeamDialog, props => <CreateEditTeamModal {...props} />),
        provideModal(addRoleMemberDialog, props => <AddRoleMemberModal {...props} />),
        provideModal(addTeamMemberDialog, props => <AddTeamMemberModal {...props} />),
      ]}
    >
      {children}
    </ModalProvider>
  );
};

export default AppModalProvider;
